<template>
  <el-dialog title="任务列表" :visible.sync="visible" width="480px" custom-class="task-list-dialog">
    <div class="task-list">
      <div v-for="mod in modules" :key="mod.moduleId">
        <div class="task-item">
          <template
            v-if="
              mod.isShow &&
              (mod.moduleType === MODULE_TYPE.PRE_STUDY ||
                mod.moduleType === MODULE_TYPE.PERSONAL_TASK ||
                mod.moduleType === MODULE_TYPE.SPECIAL_COOK)
            "
          >
            <div class="task-title">
              <div class="task-dot"></div>
              {{ mod.moduleName }}
            </div>
            <div v-if="mod.tasks && mod.tasks.length" class="task-children">
              <div v-for="child in mod.tasks" :key="child.taskId" class="task-child">
                · {{ child.taskName }}
              </div>
            </div>
          </template>
          <template v-if="mod.isShow && mod.moduleType === MODULE_TYPE.TASK">
            <div v-for="subMod in mod.modules" :key="subMod.moduleId" class="period-mod">
              <div class="task-title">
                <div class="task-dot"></div>
                {{ subMod.moduleName }}
              </div>
              <div v-if="subMod.tasks.length" class="task-children">
                <div v-for="child in subMod.tasks" :key="child.moduleId" class="task-child">
                  · {{ child.taskName }}
                </div>
              </div>
              <div
                v-if="subMod.homework && subMod.homework.tasks.length"
                class="task-children with-border"
              >
                <div
                  v-for="child in subMod.homework.tasks"
                  :key="child.moduleId"
                  class="task-child"
                >
                  · {{ child.taskName }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'TaskListDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    periodsId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      MODULE_TYPE: {
        PRE_STUDY: 1,
        TASK: 2,
        HOMEWORK: 3,
        PERSONAL_TASK: 4,
        SPECIAL_COOK: 5,
      },
      modules: [],
    };
  },
  watch: {
    show: {
      immediate: true,
      async handler(val) {
        this.visible = val;
        if (val) {
          const data = await this.$http.get('/aiclass/lesson/tasks', {
            periodsId: this.periodsId,
          });
          // const data = {
          //   periodsId: '99',
          //   periodsName: '0618-test-01',
          //   modules: [
          //     {
          //       moduleId: '94',
          //       moduleName: '课堂学习',
          //       moduleType: 2,
          //       preModuleId: null,
          //       tasks: [
          //         {
          //           taskId: '116',
          //           taskName: '知识点讲解 - 平行线基础',
          //         },
          //         {
          //           taskId: '117',
          //           taskName: '例题讲解 - 平行线基础',
          //         },
          //         {
          //           taskId: '129',
          //           taskName: '知识点讲解 - 相交线与平行线',
          //         },
          //         {
          //           taskId: '130',
          //           taskName: '例题讲解 - 相交线与平行线',
          //         },
          //       ],
          //     },
          //     {
          //       moduleId: '95',
          //       moduleName: '巩固作业',
          //       moduleType: 3,
          //       preModuleId: '94',
          //       tasks: [
          //         {
          //           taskId: '118',
          //           taskName: '作业 - 平行线基础',
          //         },
          //         {
          //           taskId: '131',
          //           taskName: '作业 - 相交线与平行线',
          //         },
          //       ],
          //     },
          //     {
          //       moduleId: '96',
          //       moduleName: '个性化大纲',
          //       moduleType: 5,
          //       preModuleId: null,
          //       tasks: [
          //         {
          //           taskId: '1181',
          //           taskName: '个性化大纲 - 平行线基础',
          //         },
          //         {
          //           taskId: '1311',
          //           taskName: '个性化大纲 - 相交线与平行线',
          //         },
          //       ],
          //     },
          //   ],
          // };
          this.modules = this.handleModules(data && data.modules);
        }
      },
    },
    visible(val) {
      if (!val) {
        this.$emit('update:show', false);
      }
    },
  },
  methods: {
    handleModules(modules = []) {
      const resultMods = [
        {
          moduleId: 'prestudy-0',
          moduleName: '',
          moduleType: this.MODULE_TYPE.PRE_STUDY,
          isShow: false,
          tasks: [],
        },
        // 虚拟集合
        {
          moduleId: 'task-1',
          moduleType: this.MODULE_TYPE.TASK,
          isShow: false,
          // 多课时
          modules: [],
        },
        {
          moduleId: 'personal-task-2',
          moduleName: '',
          moduleType: this.MODULE_TYPE.PERSONAL_TASK,
          isShow: false,
          tasks: [],
        },
        {
          moduleId: 'special-cook-task',
          moduleName: '',
          moduleType: this.MODULE_TYPE.SPECIAL_COOK,
          isShow: false,
          tasks: [],
        },
      ];

      // 临时存储作业模块
      const homeworkModules = [];
      modules.forEach((mod) => {
        if (mod.moduleType === this.MODULE_TYPE.HOMEWORK) {
          homeworkModules.push(mod);
          return;
        }
        if (mod.moduleType === this.MODULE_TYPE.PRE_STUDY) {
          const preTask = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.PRE_STUDY);
          Object.assign(preTask, {
            moduleId: mod.moduleId,
            moduleName: mod.moduleName,
            moduleType: mod.moduleType,
            isShow: true,
            tasks: mod.tasks,
          });
        } else if (mod.moduleType === this.MODULE_TYPE.SPECIAL_COOK) {
          const specialTask = resultMods.find(
            (t) => t.moduleType === this.MODULE_TYPE.SPECIAL_COOK,
          );
          Object.assign(specialTask, {
            moduleId: mod.moduleId,
            moduleName: mod.moduleName,
            moduleType: mod.moduleType,
            isShow: true,
            tasks: mod.tasks,
          });
        } else if (mod.moduleType === this.MODULE_TYPE.PERSONAL_TASK) {
          const personalTask = resultMods.find(
            (t) => t.moduleType === this.MODULE_TYPE.PERSONAL_TASK,
          );
          Object.assign(personalTask, {
            moduleId: mod.moduleId,
            moduleName: mod.moduleName,
            moduleType: mod.moduleType,
            isShow: true,
            tasks: mod.tasks,
          });
        } else if (mod.moduleType === this.MODULE_TYPE.TASK) {
          // 主要课时！！
          const periodMod = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
          periodMod.isShow = true;
          periodMod.modules.push(mod);
        }
      });
      // 处理剩余的作业（关联的课时还未处理的情况）
      const periodMod = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
      homeworkModules.forEach((homework) => {
        const targetTask = periodMod.modules.find((task) => task.moduleId === homework.preModuleId);
        if (targetTask && !targetTask.homeworks) {
          targetTask.homework = homework;
        }
      });
      return resultMods;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .task-list-dialog {
  padding: 24px;
  padding-left: 32px;

  .el-dialog__header {
    padding-top: 0;
    text-align: center;
    padding-bottom: 0;
    margin-bottom: 16px;
    font-weight: bolder;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 486px;
  }
}

.task-list {
  .task-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .task-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #1d1b20;
    line-height: 22px;
    padding-bottom: 8px;
    padding-top: 4px;

    .task-dot {
      width: 4px;
      height: 16px;
      background: #ff2020;
      border-radius: 2px;
      margin-right: 8px;
    }
  }

  .task-children {
    &.with-border {
      border-top: 1px solid #f1f3f9;
    }
    .task-child {
      font-size: 14px;
      color: #1e1c22;
      line-height: 28px;
      padding-left: 12px;
      margin-bottom: 4px;
    }
  }
}
.period-mod {
  margin-bottom: 16px;
}
</style>
